<template>
	<div>
		<!-- <com-back name="Efectivo"></com-back> -->
		<div class="wrapper">
			<div class="des">
				De clic en "PAGAR" y revise la referencia o el código de barra de pago, puede mostrarlo directamente en el
				cajero de tienda al pagar.
			</div>
			<div class="top_bg">
				<div class="top">
					<div class="info">
						<div class="title">Pendiente de pago ($)</div>
						<div class="sun_title">{{ repayAmount ? repayAmount : 0 }}</div>
					</div>
					<div class="info">
						<div class="title">Comisión</div>
						<div class="sun_title" v-if="dataTax.channelPaymentTaxSwith == 'on'">
							{{ addComma(dataTax.channelTaxAmount) }}
						</div>
						<div class="sun_title under_title" v-else>
							{{ addComma(dataTax.channelTaxAmount) }}
						</div>
					</div>
				</div>
				<div class="tips">
					<img src="@/assets/image/internal/tips.webp" alt="" />
					<p>
						Elige a PSE como método de pago, con una tasa de trámite de sólo
						<span>{{ addComma(dataTax.otherChannelTaxAmount) }}</span>
					</p>
				</div>
				<!-- <img
					src="@/assets/image/internal/payment/jianmian_efe.png"
					alt=""
					class="jianmian_efe_img"
					v-if="dataTax.channelPaymentTaxSwith == 'off' || getQueryVariable('reduction') == 1"
				/> -->
			</div>
			<div class="middle">
				<div class="title">Elegir una tienda</div>
				<div class="img">
					<div v-for="(item, index) in dataIcon" :key="index" :class="{ active: activeIndex == index }">
						<img :src="item.logo" alt="" @click="handleImg(item.code, index)" class="dataImg" />
					</div>
				</div>
			</div>
			<div class="redio" v-if="isShowRedio == 1">
				<div @click="changeRedio">
					<img src="@/assets/image/internal/select.webp" alt="" v-if="autoReloan == 1" />
					<img src="@/assets/image/internal/select_no.webp" v-else alt="" />
				</div>
				<span>Después de liquidar, obtener el nuevo límite y depositarlo directamente a mi cuenta bancaria</span>
			</div>
			<div class="redio_des">
				Para evitar retrasos en la obtención de tu nuevo crédito debido a los largos tiempos de procesamiento bancario,
				puedes marcar esta opción para obtener los fondos rápidamente. Garantizamos que la tarifa del nuevo préstamo no
				excederá la tarifa de préstamo actual y con un límite mayor.
			</div>
			<div class="bottom">
				<van-button @click="handleButton"> PAGAR ({{ total ? '$' + total : 0 }}) </van-button>
			</div>
		</div>
	</div>
</template>
<script>
	import common from '@/mixins/common.js'
	import { addComma, getQueryVariable } from '@/utils/internal'
	// import comBack from '@/components/internal/back.vue'
	export default {
		mixins: [common],
		data() {
			return {
				dataTax: {},
				repayAmount: '',
				dataIcon: [],
				activeIndex: null,
				imgCode: '',
				disabledButton: false,
				autoReloan: 0,
				isShowRedio: 0,
			}
		},
		components: {
			// comBack,
		},
		mounted() {
			this.repayAmount = this.addComma(this.getQueryVariable('repayAmount'))
			document.title = this.$route.query.name
			this.getApiHead()
			this.getAccessToken()
			this.getRepayTax()
			this.getCashType()
			this.appStatisticsNew()
			this.getAutoReloan()
			window.callbackRiskToken = this.callbackRiskToken
		},
		computed: {
			total() {
				if (this.dataTax.channelPaymentTaxSwith == 'on') {
					return this.addComma(Number(this.repayAmount.replace(/,/g, '')) + Number(this.dataTax.channelTaxAmount))
				} else if (this.dataTax.channelPaymentTaxSwith == 'off') {
					return this.addComma(Number(this.repayAmount.replace(/,/g, '')))
				} else return 0
			},
		},
		methods: {
			addComma,
			getQueryVariable,
			changeRedio() {
				if (this.autoReloan == 1) {
					this.autoReloan = 0
				} else {
					this.autoReloan = 1
				}
			},
			saveAutoReloan() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/autoReloan/update', {
						...this.params,
						autoReloan: this.autoReloan,
					})
					.then(() => {})
			},
			getAutoReloan() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/autoReloan', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.autoReloan = res.data.data?.result
						}
					})
			},
			appStatisticsNew() {
				console.log('this.apiHeadGatewayVh---', this.apiHeadGatewayVh)
				this.$axios
					.post(this.apiHeadGatewayVh + 'auth/appsflyer/appStatisticsNew', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.isShowRedio = res.data.data?.repayPageShowAutoReloan
						}
					})
			},
			//Obtain handling fees
			getRepayTax() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'getRepayTax', {
						...this.params,
						paymentType: this.getQueryVariable('paymentType'),
						channelNo: this.getQueryVariable('channelNo'),
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.dataTax = JSON.parse(res.data.data)
							console.log(this.dataTax)
						}
					})
			},
			//Get Icon
			getCashType() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'payment/cashTypes', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							console.log(JSON.parse(res.data.data))
							this.dataIcon = JSON.parse(res.data.data)
						}
					})
			},
			//click on the icon
			handleImg(code, index) {
				this.activeIndex = index
				this.imgCode = code
				this.disabledButton = true
			},
			getRiskTokenByConfig() {
				console.log('getRiskTokenByConfig--efectivo---------')
				let string = JSON.stringify({
					code: 3,
					smsFlag: 1,
					calendarFlag: 1,
					appListFlag: 1,
					reqPermission: 0,
					locationFlag: 1,
					trace: (Math.floor(Math.random() * 1000000) + 1).toString(),
				})
				window.android?.getRiskTokenByConfig(string)
			},
			callbackRiskToken(node, token, trace) {
				console.log('callbackRiskToken--efectivo----', node, token, trace)
				this.$axios
					.post(
						this.apiHeadGatewayVh + 'repay/record/create',
						{
							...this.params,
							tokenKey: token,
							orderId: this.getQueryVariable('orderId'),
							acctAmount: this.repayAmount.replace(/,/g, ''),
							channelNo: this.getQueryVariable('channelNo'),
							paymentType: this.getQueryVariable('paymentType'),
							cashType: this.imgCode,
							channelTaxAmount: this.dataTax.channelPaymentTaxSwith == 'on' ? this.dataTax.channelTaxAmount : 0,
						},
						{ timeout: 60000 },
					)
					.then((res) => {
						if (res.data.code == 0) {
							window.open(res.data.data.token)
						}
					})
			},
			//Button Jump
			handleButton() {
				if (this.disabledButton == false) {
					this.$toast('Por favor elija la tienda')
				} else {
					if (this.isShowRedio) this.saveAutoReloan()
					this.getRiskTokenByConfig()
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/efectivo.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
